import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { getStoredConsent, trackPageView, updateAnalyticsConsent } from "../lib/analytics";

export default function AnalyticsBridge() {
  const location = useLocation();
  const [isAnalyticsAllowed, setIsAnalyticsAllowed] = useState(() => getStoredConsent() === "granted");
  const lastTrackedPath = useRef("");

  useEffect(() => {
    const handleConsentUpdate = (event) => setIsAnalyticsAllowed(event.detail.granted);
    window.addEventListener("pimp-consent-updated", handleConsentUpdate);
    return () => window.removeEventListener("pimp-consent-updated", handleConsentUpdate);
  }, []);

  useEffect(() => {
    if (isAnalyticsAllowed) {
      updateAnalyticsConsent(true);
    }
  }, [isAnalyticsAllowed]);

  useEffect(() => {
    if (!isAnalyticsAllowed) {
      lastTrackedPath.current = "";
      return;
    }
    const currentPath = `${location.pathname}${location.search}`;
    if (lastTrackedPath.current === currentPath) return;
    lastTrackedPath.current = currentPath;
    trackPageView();
  }, [isAnalyticsAllowed, location.pathname, location.search]);

  return null;
}